import pluralize from 'pluralize';

import {
  Icons,
  TableRecordsCount,
  LinkBehaviour,
  Box,
} from '@cast/design-system';

import { useSearchContext } from '@cast/shared-search-ui';

type ClusterListRecordsCountProps = {
  activeCount?: number;
  notFoundCount: number;
  onOpenNotFoundDrawer?: () => void;
};

export const ClusterListRecordsCount = ({
  activeCount: activeCountProp,
  notFoundCount,
  onOpenNotFoundDrawer,
}: ClusterListRecordsCountProps) => {
  const searchCtx = useSearchContext();
  const activeCount = activeCountProp ?? searchCtx?.filteredData?.length ?? 0;

  if (searchCtx?.isLoading || (!activeCount && !notFoundCount)) {
    return <Box height={22} />;
  }

  return (
    <TableRecordsCount>
      {activeCount} {pluralize('cluster', activeCount)}
      {notFoundCount > 0 && onOpenNotFoundDrawer && (
        <>
          {' | '}
          <LinkBehaviour
            component="button"
            variant="inherit"
            onClick={onOpenNotFoundDrawer}
            testId="not-found-clusters-link"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              color: 'blue.500',
              verticalAlign: 'baseline',
              background: 'transparent',
              border: 0,
              padding: 0,
              appearance: 'none',
              font: 'inherit',
              '&:hover': {
                color: 'blue.600',
                textDecoration: 'underline',
              },
            }}
          >
            {notFoundCount} {pluralize('cluster', notFoundCount)} not found
            <Icons.ArrowRight size={12} />
          </LinkBehaviour>
        </>
      )}
    </TableRecordsCount>
  );
};
